module.exports = __webpack_public_path__ + "static/media/stock.b627096d.jpg";